import { FormControl } from '@angular/forms';
import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { positiveNotNull, requiredNotNull } from '../form-control-options.constants';
import { BaseFormControls } from './base.form-controls';

export abstract class QuickActionFormControls extends BaseFormControls {
  amount = new FormControl(1, positiveNotNull);
  stockItem = new FormControl<ProductActiveStockItem | null>(null);
}

export class QuickActionConsumeFormControls extends QuickActionFormControls {
  spoiled = new FormControl(false, requiredNotNull);
}

export class QuickActionOpenFormControls extends QuickActionFormControls {}

export class QuickActionTransferFormControls extends QuickActionFormControls {
  override stockItem = new FormControl<ProductActiveStockItem | null>(null, requiredNotNull);
  fromLocation = new FormControl<EntityReference | null>(null, requiredNotNull);
  toLocation = new FormControl<EntityReference | null>(null, requiredNotNull);
}
